// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!./form-summary-stock-actions.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("31853880", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./App/Components/PrintSummary/form-summary-stock-actions.css
// module id = 67
// module chunks = 0